import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import StudentinfoComponent from '../components/studentinfo/studentinfo.jsx';
import {closeStudentinfoModal,openTermreportModal} from "../redux/actions/modelsActive";
import {getBadgeListRequest} from "../service/user";
import {getHzDzRankingRequest} from "../service/report";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

class StudentinfoContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'getBadgeList',
            'openFaceCollectPrompt',
            'openTermreportPrompt',
            'onCancel'
        ]);
        this.state = {
            hzsum:'',
            yemian:'',
            jihao:[],
            showFaceCollectPrompt:false
        }

    }


    componentDidMount() {

        this.getBadgeList();
    }

    openTermreportPrompt(){
        this.props.openTermreportModal();
    }

    openFaceCollectPrompt(){
        this.setState({
            showFaceCollectPrompt:true
        })

        // const doc = new jsPDF();
        // const element = document.getElementById('root');
        // doc.html(element, {
        //     callback: function (pdf) {
        //         pdf.save('exported.pdf');
        //     }
        // });

        //this.downloadPDF()
    }

    downloadPDF() {
        const convertToPDF = async () => {
            const divElement = document.getElementById('test2');
            const canvas = await html2canvas(divElement);
            const imgData = canvas.toDataURL('image/png',1.0);
            const pdf = new jsPDF();
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            // 添加图片到 PDF
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            // 保存 PDF
            pdf.save("output.pdf");


            // 将 canvas 转换为 Blob 对象
            // canvas.toBlob((blob) => {
            //     if (blob) {
            //         const url = URL.createObjectURL(blob);
            //         const a = document.createElement('a');
            //         a.href = url;
            //         a.download = 'output.png';
            //         document.body.appendChild(a);
            //         a.click();
            //         document.body.removeChild(a);
            //         URL.revokeObjectURL(url);
            //     }
            // }, 'image/png');

        };

        convertToPDF();

    }

    onCancel(){
        this.setState({
            showFaceCollectPrompt:false
        })
    }

    getBadgeList(){
        getBadgeListRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            if(data.ret=='1'){
                this.setState({
                    hzsum:data.data.hzsum,
                    yemian:data.data.yemian,
                    jihao:data.data.jihao
                });

            }
        });

        getHzDzRankingRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            if(data.ret=='1'){
                this.setState({
                    badgeMineNum:data.data.student_hz_dz.badge,
                    badgeAverageNum:data.data.class_avg.bavg,
                    badgeMaxNum:data.data.class_avg.bmax,
                    paiming:data.data.student_hz_dz.bpm
                });


            }
        });
    }



    render() {

        return (
            <StudentinfoComponent
                hzsum={this.state.hzsum}
                jihao={this.state.jihao}
                yemian={this.state.yemian}
                showFaceCollectPrompt={this.state.showFaceCollectPrompt}
                closeStudentinfoModal={this.props.closeStudentinfoModal}
                openFaceCollectPrompt={this.openFaceCollectPrompt}
                openTermreportPrompt={this.openTermreportPrompt}
                onCancel={this.onCancel}
            />
        )
    }


}

StudentinfoContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeStudentinfoModal: () => dispatch(closeStudentinfoModal()),
        openTermreportModal: () => dispatch(openTermreportModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentinfoContainer);
